import { delay, put, race, take } from 'redux-saga/effects';

import { env } from '@/env';
import { callWhenOnline } from '@/modules/network';

import { activateSyncSecrets, syncSecrets } from '../actions';

export const SYNC_SECRETS_TIMEOUT = (env.VITE_LOCALHOST ? 5 : 30) * 60 * 1000; // 5 or 30 minutes

function* syncingSaga() {
    while (true) {
        const result: { delay?: true; sync?: unknown } = yield race({
            delay: delay(SYNC_SECRETS_TIMEOUT),
            sync: take(syncSecrets.toString()),
        });

        if (result.delay) {
            yield put(syncSecrets());
        }
    }
}

export default function* () {
    yield take(activateSyncSecrets.toString());

    yield callWhenOnline(syncingSaga);
}
